import { useMemo, useCallback } from 'react';

import { useFormTemplatesByUidMap } from './useEntitiesMap';
import { FEATURE_FLAGS } from '../helpers/constants';
import { usePlangridFeatureFlag } from '../PlangridLaunchDarklyProvider';
import { CacaForm } from '../types';

// with APS endpoints, we no longer have access to template name on Form object, we need to associate it from templates data
const useTemplateName = (form: CacaForm) => {
  const { data: formTemplatesMap, loading: isLoadingFormTemplatesMap } =
    useFormTemplatesByUidMap();
  const { value: isScalingFormsM7Enabled } = usePlangridFeatureFlag(
    FEATURE_FLAGS.SCALING_FORMS_M7,
    false,
  );

  const getTemplateName = useCallback(
    (form: CacaForm) => {
      if (isLoadingFormTemplatesMap) {
        return '';
      }

      return isScalingFormsM7Enabled
        ? formTemplatesMap[form.type]?.name
        : form.report_type.name;
    },
    [formTemplatesMap, isLoadingFormTemplatesMap, isScalingFormsM7Enabled],
  );
  const templateName = useMemo(() => {
    if (!form) {
      return '';
    }
    return getTemplateName(form);
  }, [form, getTemplateName]);
  return { templateName, getTemplateName };
};

export default useTemplateName;
